var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-wishlist-add.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"ownerView") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"source") == "wishlist";
frame.set("isInWishlist", t_1, true);
if(frame.topLevel) {
context.setVariable("isInWishlist", t_1);
}
if(frame.topLevel) {
context.addExport("isInWishlist", t_1);
}
var t_2;
t_2 = (lineno = 1, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["quickshop.showMoveToList",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("showMoveToList", t_2, true);
if(frame.topLevel) {
context.setVariable("showMoveToList", t_2);
}
if(frame.topLevel) {
context.addExport("showMoveToList", t_2);
}
var t_3;
t_3 = !(lineno = 2, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.hideListAddLinks",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("showListAddLinks", t_3, true);
if(frame.topLevel) {
context.setVariable("showListAddLinks", t_3);
}
if(frame.topLevel) {
context.addExport("showListAddLinks", t_3);
}
var t_4;
t_4 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToWishList")),"canAddToWishList");
frame.set("canAddToWishList", t_4, true);
if(frame.topLevel) {
context.setVariable("canAddToWishList", t_4);
}
if(frame.topLevel) {
context.addExport("canAddToWishList", t_4);
}
var t_5;
t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteId") == "an-us" || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteConfig")),"siteGroup") == "an-us";
frame.set("isAnthroUS", t_5, true);
if(frame.topLevel) {
context.setVariable("isAnthroUS", t_5);
}
if(frame.topLevel) {
context.addExport("isAnthroUS", t_5);
}
var t_6;
t_6 = !runtime.contextOrFrameLookup(context, frame, "isAnthroUS") || ((lineno = 5, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["quickshop.isOpen",runtime.contextOrFrameLookup(context, frame, "False")])) && !(lineno = 5, colno = 88, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["quickshop.showAddToRegistry",runtime.contextOrFrameLookup(context, frame, "False")])));
frame.set("leftAlignWishList", t_6, true);
if(frame.topLevel) {
context.setVariable("leftAlignWishList", t_6);
}
if(frame.topLevel) {
context.addExport("leftAlignWishList", t_6);
}
output += "<li class=\"g-sku-action__link\n    c-product-add-links__li\n    c-product-add-to-wishlist__li\n    ";
if(runtime.contextOrFrameLookup(context, frame, "leftAlignWishList")) {
output += "c-product-add-to-wishlist__li--left";
;
}
output += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "isInWishlist")) {
output += "c-product-change-wishlist";
;
}
output += "\n    dom-wishlist-add\">\n    ";
if(runtime.contextOrFrameLookup(context, frame, "isInWishlist") || runtime.contextOrFrameLookup(context, frame, "showListAddLinks")) {
var t_7;
t_7 = runtime.contextOrFrameLookup(context, frame, "isInWishlist") && !(runtime.contextOrFrameLookup(context, frame, "canAddToWishList") && runtime.contextOrFrameLookup(context, frame, "showMoveToList"));
frame.set("isDisabled", t_7, true);
if(frame.topLevel) {
context.setVariable("isDisabled", t_7);
}
if(frame.topLevel) {
context.addExport("isDisabled", t_7);
}
var t_8;
t_8 = (runtime.contextOrFrameLookup(context, frame, "isDisabled")?"u-link--disabled is-disabled":"");
frame.set("disabledClass", t_8, true);
if(frame.topLevel) {
context.setVariable("disabledClass", t_8);
}
if(frame.topLevel) {
context.addExport("disabledClass", t_8);
}
var t_9;
t_9 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToWishList")),"isPending") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToWishList")),"isSuccess");
frame.set("wishlistPending", t_9, true);
if(frame.topLevel) {
context.setVariable("wishlistPending", t_9);
}
if(frame.topLevel) {
context.addExport("wishlistPending", t_9);
}
var t_10;
t_10 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToWishList")),"isSuccess") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productAddToWishList")),"isPending");
frame.set("wishlistSuccess", t_10, true);
if(frame.topLevel) {
context.setVariable("wishlistSuccess", t_10);
}
if(frame.topLevel) {
context.addExport("wishlistSuccess", t_10);
}
if(runtime.contextOrFrameLookup(context, frame, "isInWishlist")) {
var t_11;
t_11 = "move item";
frame.set("wishlistEventAction", t_11, true);
if(frame.topLevel) {
context.setVariable("wishlistEventAction", t_11);
}
if(frame.topLevel) {
context.addExport("wishlistEventAction", t_11);
}
;
}
else {
var t_12;
t_12 = (runtime.contextOrFrameLookup(context, frame, "forFamilyProduct")?"family | add to wish list click":"add to wish list click");
frame.set("wishlistEventAction", t_12, true);
if(frame.topLevel) {
context.setVariable("wishlistEventAction", t_12);
}
if(frame.topLevel) {
context.addExport("wishlistEventAction", t_12);
}
;
}
output += "\n\n        <a href=\"#\"\n            class=\"js-create-wishlist-ui c-product-add-links__a c-product-add-to-wishlist__a c-product-add__";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "canAddToWishList"), env.opts.autoescape);
output += " ";
if(runtime.contextOrFrameLookup(context, frame, "wishlistPending")) {
output += " is-pending ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "wishlistSuccess")) {
output += " is-success ";
;
}
;
}
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "disabledClass"), env.opts.autoescape);
output += "\"\n            ";
output += runtime.suppressValue((lineno = 29, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE",runtime.contextOrFrameLookup(context, frame, "wishlistEventAction"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"displayName")])), env.opts.autoescape);
output += "\n            data-qa-add-to-wishlist=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "wishlistSuccess"), env.opts.autoescape);
output += "\"\n        >\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "wishlistPending") && !runtime.contextOrFrameLookup(context, frame, "wishlistSuccess")) {
output += "<span class=\"c-product-add-links__text\">\n                    <span class=\"c-product-add-links__circle\"></span>\n                    <span class=\"c-product-add-links__circle\"></span>\n                    <span class=\"c-product-add-links__circle\"></span>\n                </span>\n\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "wishlistSuccess") && !runtime.contextOrFrameLookup(context, frame, "wishlistPending")) {
output += "\n                    ";
output += runtime.suppressValue((lineno = 52, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_added-to-wishlist"])), env.opts.autoescape);
output += "\n                ";
output += "\n\n            ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "isInWishlist")) {
output += runtime.suppressValue((lineno = 57, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_links-move-to-different-list"])), env.opts.autoescape);
output += "\n\n            ";
;
}
else {
output += "\n\n                    ";
output += runtime.suppressValue((lineno = 61, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_links-add-to-wishlist"])), env.opts.autoescape);
;
}
;
}
;
}
output += "\n\n        </a>\n    ";
;
}
output += "\n\n</li>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-wishlist-add.j2"] , dependencies)